export enum InputTypes {
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  COLOR = 'color',
  DATE = 'date',
  DATETIME_LOCAL = 'datetime-local',
  EMAIL = 'email',
  FILE = 'file',
  HIDDEN = 'hidden',
  IMAGE = 'image',
  MONTH = 'month',
  NUMBER = 'number',
  PASSWORD = 'password',
  RADIO = 'radio',
  RANGE = 'range',
  RESET = 'reset',
  SEARCH = 'search',
  SUBMIT = 'submit',
  TEL = 'tel',
  TEXT = 'text',
  TIME = 'time',
  URL = 'url',
  WEEK = 'week',
}
export enum SelectTypes {
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  COLOR = 'color',
  DATE = 'date',
  DATETIME_LOCAL = 'datetime-local',
  EMAIL = 'email',
  FILE = 'file',
  HIDDEN = 'hidden',
  IMAGE = 'image',
  MONTH = 'month',
  NUMBER = 'number',
  PASSWORD = 'password',
  RADIO = 'radio',
  RANGE = 'range',
  RESET = 'reset',
  SEARCH = 'search',
  SUBMIT = 'submit',
  TEL = 'tel',
  TEXT = 'text',
  TIME = 'time',
  URL = 'url',
  WEEK = 'week',
}

export enum TagTypes {
  WARNING = 'warning',
  WRONG = 'wrong',
  POSITIVE = 'positive',
  TRIAL = 'trial',
  NEUTRAL = 'neutral',
  DEFAULT_WHITE = 'default-white',
  SHADOW_WHITE = 'shadow-white',
}
export enum AttendanceTagTypes {
  SM = 'sm',
  LG = 'lg',
  MD = 'md',
}
export enum StatusType {
  SUCCESS = 'success',
  PROCESSING = 'processing',
  ERROR = 'error',
  DEFAULT = 'default',
  WARNING = 'warning',
}
export enum SummeryType {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  EXTRASMALL = 'extraSmall',
}
export enum TabsSizeType {
  DEFAULT = 'default',
  LARGE = 'large',
  SMALL = 'small',
}
export type GridType = {
  row: {};
  col: {};
};
export type AvatarSizeType =
  | 'l'
  | 'lg'
  | 'sm'
  | 'md'
  | 'lm'
  | 'x'
  | 'xs'
  | 'xl'
  | 'xxl'
  | 'xxxl'
  | 'xxxxl'
  | 'xxs'
  | 'ssm';

export enum PaymentTypes {
  STRIPE = 'stripe',
  ARCA = 'arca',
  OMISE = 'omise',
  PAYPAL = 'paypal',
}

export type TextColorTypes =
  | 'white'
  | 'black'
  | 'primary'
  | 'blue'
  | 'indicator-neutral'
  | 'dark-10'
  | 'dark-20'
  | 'dark-30'
  | 'dark-50'
  | 'dark-100';
